var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirConditionerAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4C2 2.89543 2.89543 2 4 2H20C21.1046 2 22 2.89543 22 4V10.25H2V4ZM10 6.25C9.58579 6.25 9.25 6.58579 9.25 7C9.25 7.41421 9.58579 7.75 10 7.75H14C14.4142 7.75 14.75 7.41421 14.75 7C14.75 6.58579 14.4142 6.25 14 6.25H10Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.75H22V12C22 13.1046 21.1046 14 20 14H4C2.89543 14 2 13.1046 2 12V11.75Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00001 16.25C6.41422 16.25 6.75001 16.5858 6.75001 17V18C6.75001 19.1803 6.19428 20.2918 5.25001 21L4.45001 21.6C4.11864 21.8485 3.64854 21.7814 3.40001 21.45C3.15148 21.1186 3.21864 20.6485 3.55001 20.4L4.35001 19.8C4.91657 19.3751 5.25001 18.7082 5.25001 18V17C5.25001 16.5858 5.5858 16.25 6.00001 16.25Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 17C17.25 16.5858 17.5858 16.25 18 16.25C18.4142 16.25 18.75 16.5858 18.75 17V18C18.75 18.7082 19.0834 19.3751 19.65 19.8L20.45 20.4C20.7814 20.6485 20.8485 21.1186 20.6 21.45C20.3515 21.7814 19.8814 21.8485 19.55 21.6L18.75 21C17.8057 20.2918 17.25 19.1803 17.25 18V17Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.25C10.4142 15.25 10.75 15.5858 10.75 16V18.3431C10.75 19.6029 10.2496 20.8111 9.35876 21.7019L8.53033 22.5303C8.23744 22.8232 7.76256 22.8232 7.46967 22.5303C7.17678 22.2374 7.17678 21.7626 7.46967 21.4697L8.2981 20.6412C8.90759 20.0317 9.25 19.2051 9.25 18.3431V16C9.25 15.5858 9.58579 15.25 10 15.25Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 16C13.25 15.5858 13.5858 15.25 14 15.25C14.4142 15.25 14.75 15.5858 14.75 16V18.3431C14.75 19.2051 15.0924 20.0317 15.7019 20.6412L16.5303 21.4697C16.8232 21.7626 16.8232 22.2374 16.5303 22.5303C16.2374 22.8232 15.7626 22.8232 15.4697 22.5303L14.6412 21.7019C13.7504 20.8111 13.25 19.6029 13.25 18.3431V16Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirConditionerAlt);
export default __webpack_public_path__ + "static/media/air-conditioner-alt.370c9e29400af48c48864c2e7e0e2a25.svg";
export { ForwardRef as ReactComponent };